import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface DomeMarkProps {
    className?: string
    variant?: 'solid' | 'line'
    title?: string
}

/**
 * The Unity Dome mark: a domed pavilion with a finial and an arched doorway.
 * Drawn as a vector so it stays crisp and takes the current text color.
 */
export const DomeMark: FC<DomeMarkProps> = ({ className, variant = 'solid', title }): ReactNode => {
    const labelled = Boolean(title)

    if (variant === 'line') {
        return (
            <svg
                viewBox='0 0 40 52'
                fill='none'
                stroke='currentColor'
                strokeWidth='1.5'
                className={cn('h-auto w-6', className)}
                role={labelled ? 'img' : undefined}
                aria-hidden={labelled ? undefined : true}
            >
                {title && <title>{title}</title>}
                <circle cx='20' cy='4' r='2' />
                <path d='M20 6v6' />
                <path d='M4.75 51.25V28a15.25 15.25 0 0 1 30.5 0v23.25Z' />
                <path d='M14.5 51.25V38a5.5 5.5 0 0 1 11 0v13.25' />
                <path d='M4.75 28h30.5' />
            </svg>
        )
    }

    return (
        <svg
            viewBox='0 0 40 52'
            fill='currentColor'
            className={cn('h-auto w-6', className)}
            role={labelled ? 'img' : undefined}
            aria-hidden={labelled ? undefined : true}
        >
            {title && <title>{title}</title>}
            <circle cx='20' cy='4' r='2.25' />
            <rect x='19.25' y='5' width='1.5' height='8' />
            <path fillRule='evenodd' d='M4 52V28a16 16 0 0 1 32 0v24Zm10 0V38a6 6 0 0 1 12 0v14Z' />
        </svg>
    )
}
